import React, { useState } from "react";
import { Styles } from "../award-event/styles/awardEvent";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../components/Footer";
import "./styles/event-common.css";

const Event11 = () => {
  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper event-page">
        {/* Header 2 */}
        <Header />

        {/* Breadcroumb */}
        <BreadcrumbBox title="Event" img="16_5.jpeg" />
        <Container>
          <Row>
            <Col>
              <a
                href="/news"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  lineHeight: "40px",
                }}
              >
                Back To News
              </a>
            </Col>
          </Row>
        </Container>

        {/* News Area */}
        <section className="award-page">
          <Container>
            <Row>
              <Col md="12">
                <div style={{ padding: "20px 0" }}>
                  <h2
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "black",
                    }}
                  >
                    কল্পনার শহর | CWIS mini-series | EP 1 | RESPONSIBILITY
                  </h2>

                  

                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "20px 0",
                    }}
                  >
                   একটা শহর তখন বদলে যায়, যখন আমরা নিজেদের দায়িত্ব বুঝে নেই। দেখুন CWIS মিনি সিরিজের প্রথম পর্ব \"দায়িত্বশীলতা\", যেখানে প্রতিটি মানুষের ছোট ছোট উদ্যোগ তৈরি করে নিরাপদ, ন্যায্য ও টেকসই শহরের গল্প। শহরব্যাপী অন্তর্ভুক্তিমূলক স্যানিটেশন (বা সিটিওয়াইড ইনক্লুসিভ স্যানিটেশন/ CWIS) আমাদের মনে করিয়ে দেয় যে, পৌরসভা কর্তৃক সঠিক স্যানিটেশন সেবা প্রদানে আমাদের সকলের দায়িত্বশীল আচরণ অপরিহার্য । A city changes when we understand our responsibilities. Watch the first episode of the CWIS mini-series \"Responsibility,\" where small initiatives from every person create safe, equitable, and sustainable cities. Citywide Inclusive Sanitation (CWIS) reminds us to behave responsibly to ensure proper sanitation services are in place by municipalities.
                   <br /> <br />
                   Video Link: <a
                      href="https://youtu.be/8rXJaa-HALY?si=hGEKzzE17BFEs9VO"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://youtu.be/8rXJaa-HALY?si=hGEKzzE17BFEs9VO
                    </a>
                  </p>
                  
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </Styles>
  );
};

export default Event11;
